import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import config from '../../config'
import {
  Link,
  LinkIcon,
  CompanyIsFlag
} from '../'
import Styles from './CompanyIsPff.css'


@CSSModules(Styles, {allowMultiple:true})
export default class CompanyIsPff extends Component {
  static propTypes = {
    company: PropTypes.object.isRequired,
  }
  constructor(props){
    super(props)

    const entry = config.pffCompanyProfiles.data[this.props.company.company_id]
    if (!entry) return null

    const shortName = entry[0]
    const profile = entry[1]
    const types = entry[2].split(',')
    const url = entry[3]
    const isPrisonIndustry = entry[4]
    const isBorderIndustry = entry[5]
    const isHigherRisk = (entry[6]) && !(entry[7]) // only "high risk" if not
                                                   // private prison operator
    const isPrivatePrisonOperator = entry[7]

    this.state = {
      shortName,
      profile,
      types,
      url,
      isPrisonIndustry,
      isBorderIndustry,
      isHigherRisk,
      isPrivatePrisonOperator,
    }
  }

  render() {
    const { shortName, profile, types, url, isPrisonIndustry,
            isBorderIndustry, isHigherRisk,
            isPrivatePrisonOperator } = this.state

    const ppIcon = require( '../../../static/images/icn-pp-black.svg' )
    const bordersIcon = require( '../../../static/images/icn-borders-black.svg' )
    const highIcon = require( '../../../static/images/icn-alert-red.svg' )

    return <div>
      <div styleName='family-modal'>
        <div styleName='icon-row'>
          {
            isHigherRisk ?
              <CompanyIsFlag icon={highIcon} title='Higher risk' color='red'/> :
              null
          }
          {
            isPrivatePrisonOperator ?
              <CompanyIsFlag icon={highIcon} title='Private prison operator' color='red'/> :
              null
          }
          {
            isPrisonIndustry ?
              <CompanyIsFlag icon={ppIcon} title='Prison industry'/> :
              null
          }
          {
            isBorderIndustry ?
              <CompanyIsFlag icon={bordersIcon} title='Border industry'/> :
              null
          }
        </div>
        <div styleName='family-modal-p'>
          {profile}
        </div>
        <div styleName='family-modal-t'>
          Prison industrial complex activities
        </div>
        <div styleName='cat-flex'>
          {
            types.map((e, i) => {
              return <div key={'type-' + i}  styleName='cat-item'>
                {e.trim()}
              </div>
            })
          }
        </div>
        <div styleName='family-modal-u'>
          <Link
            to={url}
            title={
              shortName + ' | Investigate: a project of the ' +
                'American Friends Service Committee'
            }
          >
            Research from AFSC's Investigate<LinkIcon />
          </Link>
        </div>
      </div>
    </div>
  }
}

